/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import permissions from '../../../common/constants/permissions';

import './header.tpl.html';

/**
 * Module for the admin header view.
 */
angular
  .module('shared.header', ['services.error', 'services.permissions', 'services.config', 'shared.modal'])
  .controller(
    'SharedHeaderCtrl',
    function (
      $scope,
      $filter,
      $state,
      $uibModal,
      $rootScope,
      $timeout,
      $window,
      accountUtils,
      viewUtils,
      billingUtils,
      bodyUtils,
      authFactory,
      batchUtils,
      ErrorService,
      configService,
      ALERT_EVENTS,
      BATCH_LIMITS,
      VIEW_STATES,
      permissionService
    ) {
      // configure view scope value that drive view selector.
      var viewObj = viewUtils.getViewObject($state.current.name);

      $scope.inRenewal = false;
      $scope.viewData = Object.assign({}, viewUtils.viewData);
      $scope.currentIcon = viewObj.icon;
      $scope.currentTitle = $filter('i18n')(viewObj.title);
      $scope.showExtras = true;
      $scope.inTrial = false;
      $scope.isExpiredOrg = billingUtils.isAccessStopped();
      $scope.isMaintenanceMode = $rootScope.maintenanceModeFlag;
      $scope.accessError = $rootScope.accessError;
      $scope.trialDaysRemaining = 0;
      $scope.trialLength = 14; // default to 14
      $scope.alerts = [];
      $scope.headerTooltip = '';
      $scope.orgName = '';
      $scope.orgId = '';
      $scope.type = '';
      $scope.status = '';
      $scope.actor = { username: '' };

      checkViewDataPermission('export', permissions.EXPORT);
      checkViewDataPermission('metadataCompare', permissions.METADATA_COMPARE);
      checkViewDataPermission('restore', permissions.RESTORE);
      checkViewDataPermission('activityHistory', permissions.ACTIVITY_HISTORY);
      checkViewDataPermission('account', permissions.SETTINGS);

      // bind $rootScope.$on success event
      $rootScope.$on(ALERT_EVENTS.SUCCESS.eventName, function (evtObj, msg, skipTimeout, onClick) {
        $scope.addAlert({
          type: ALERT_EVENTS.SUCCESS.type,
          text: msg,
          skipTimeout: skipTimeout,
          onClick: onClick
        });
      });

      // bind $rootScope.$on error event
      $rootScope.$on(ALERT_EVENTS.ERROR.eventName, function (evtObj, msg, skipTimeout, onClick) {
        $scope.addAlert({
          type: ALERT_EVENTS.ERROR.type,
          text: msg,
          skipTimeout: skipTimeout,
          onClick: onClick
        });
      });

      // bind $rootScope.$on close event
      $rootScope.$on(ALERT_EVENTS.CLOSE.eventName, function () {
        $scope.clearAllAlerts();
      });

      // bind $rootScope.$on $stateChangeSuccess.
      // when state change is successful, set current title and icon of dropdown button.
      $rootScope.$on('$stateChangeSuccess', function (event, to) {
        var viewObj;
        if (to && to.name) {
          viewObj = viewUtils.getViewObject(to.name);
          if (viewObj) {
            $scope.currentTitle = $filter('i18n')(viewObj.title);
            $scope.currentIcon = viewObj.icon;
          }
        }
      });

      authFactory.displayedInChatter().then(function (displayedInChatter) {
        $scope.displayedInChatter = displayedInChatter;
      });

      // Retrieve the created value and determine whether to
      // show the help icon or hide it.
      accountUtils.getOrgInfo().then(
        function (orgObj) {
          var time = moment(orgObj.created),
            currentTime = moment();
          // Set the values for the support modal.
          $scope.orgId = orgObj.sfId;
          $scope.orgName = orgObj.name;
          $scope.showHelp = 2 >= currentTime.diff(time, 'weeks');
          $scope.betaFeaturesEnabled = orgObj.betaFeaturesEnabled;
        },
        function () {
          $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('LOAD_ORG_DATA_FAILED'));
        }
      );

      authFactory.getSignedRequest().then((actor) => {
        $scope.actor = actor;
      });

      // Load the batch dots since that determines whether the RESTORE tab is shown
      batchUtils.getBackupBatchDots(BATCH_LIMITS.NUM_BATCHES_ON_DASHBOARD);

      /**
       * Function to add alert to alert array.
       * @param {Object} msgObj - The message object that contains the text and type of the message.
       */
      $scope.addAlert = function (msgObj) {
        var clearAlerts = function () {
          $scope.alerts = [];
        };
        clearAlerts();
        $scope.alerts.push({ msg: msgObj.text, type: msgObj.type, onClick: msgObj.onClick });
        if (!msgObj.skipTimeout) {
          $timeout(clearAlerts, 10000);
        }
      };

      /**
       * Function that closes the alert box.
       * @param Number index - The index of the alert object.
       */
      $scope.closeAlert = function (index) {
        $scope.alerts.splice(index, 1);
      };

      /**
       * Function that closes all alerts.
       */
      $scope.clearAllAlerts = function () {
        $scope.alerts = [];
      };

      /**
       * Function used to determine if a message from the dropdown should show a menu item.
       *
       * @param {Object} message - A message object from the viewDate scope value.
       * @returns {boolean} - true to show the menu item.
       */
      $scope.showMessage = function (message) {
        return (
          $scope.showInTrial(message) &&
          $scope.showForInvoice(message) &&
          $scope.showForBetaFeature(message) &&
          $scope.showMessageForNoBackups(message)
        );
      };

      /**
       * Function used to determine if a message from the dropdown should show a menu item in trial.
       *
       * @param {Object} message - A message object from the viewDate scope value.
       * @returns {boolean} - true to show the menu item.
       */
      $scope.showInTrial = function (message) {
        return message.showInTrial || !$scope.inTrial;
      };

      /**
       * Function used to determine if a message from the dropdown should show a menu item for invoice.
       *
       * @param {Object} message - A message object from the viewDate scope value.
       * @returns {boolean} - true to show the menu item.
       */
      $scope.showForInvoice = function (message) {
        return !(message.hideForInvoice === true && $scope.type === 'INVOICE' && $scope.status === 'PAID');
      };

      /**
       * Function used to determine if a message from the dropdown should show a menu item for beta features.
       *
       * @param {Object} message - A message object from the viewDate scope value.
       * @returns {boolean} - true to show the menu item.
       */
      $scope.showForBetaFeature = function (message) {
        return !message.isBetaFeature || message.isBetaFeature === $scope.betaFeaturesEnabled;
      };

      /**
       * Function used to determine if a message from the dropdown should show a menu item if they have no backups.
       *
       * @param {Object} message - A message object from the viewDate scope value.
       * @returns {boolean} - true to show the menu item.
       */
      $scope.showMessageForNoBackups = function (message) {
        return !message.hideForNoBackups || (message.hideForNoBackups && batchUtils.backupBatchDots.count > 0);
      };

      /**
       * Utility function used to update billing related scope values.
       *
       * @param {Object} paymentInfo - The paymentInfo object returned from the server.
       */
      $scope.updateBillingInfo = function (paymentInfo) {
        var starts, ends, daysLeft;
        $scope.inTrial = billingUtils.inTrial();
        $scope.isExpiredOrg = billingUtils.isAccessStopped();
        // Check if in renewal period
        $scope.inRenewal = billingUtils.inRenewalPeriod();
        $scope.type = paymentInfo.type;
        $scope.status = paymentInfo.status;
        if ($scope.inTrial) {
          starts = moment(paymentInfo.starts);
          ends = moment(paymentInfo.expires);
          daysLeft = ends.diff(moment(new Date()), 'days');
          $scope.trialDaysRemaining = ends.diff(new Date(), 'days');
          daysLeft = daysLeft < 0 ? 0 : daysLeft;
          daysLeft = $filter('pluralize')(daysLeft, 'DAY_LEFT', 'DAYS_LEFT');

          $scope.trialLength = ends.diff(starts, 'days');
          $scope.headerTooltip = $filter('i18n')('TRIAL_TTIP', [daysLeft, ends.format(SBSF.messages.MDY)]);
        } else {
          $scope.headerTooltip = '';
          // Check if we are in renewal period and display header widget if necessary
          if ($scope.inRenewal) {
            ends = moment(paymentInfo.expires);
            daysLeft = ends.diff(moment(new Date()), 'days');
            $scope.subscriptionDaysRemaining = ends.diff(new Date(), 'days');
            daysLeft = daysLeft < 0 ? 0 : daysLeft;
            daysLeft = $filter('pluralize')(daysLeft, 'DAY_LEFT', 'DAYS_LEFT');
            $scope.headerTooltip = $filter('i18n')('RENEWAL_TTIP', [daysLeft, ends.format(SBSF.messages.MDY)]);
          }
        }
      };

      billingUtils
        .getPaymentInfo()
        .then($scope.updateBillingInfo)
        .catch(function (err) {
          $rootScope.showLoadingMask = false;
          ErrorService.report(err);
        });

      /**
       * Function called to show the admin view.
       */
      $scope.goToAdmin = function () {
        $scope.goToPage(VIEW_STATES.ADMIN_HOME);
      };

      /**
       * Function called to redirect to the self service payment.
       */
      $scope.goToPurchase = function () {
        Promise.all([configService.getBillingUrls(), accountUtils.getOrgInfo()]).then(([billing, orgInfo]) => {
          let selfServiceAddress;
          if (billingUtils.inTrial() && !orgInfo.reseller) {
            selfServiceAddress = billing.kaseyaPortalRegistrationLink;
          } else {
            selfServiceAddress = billing.kaseyaPortalLink;
          }
          $window.open(selfServiceAddress, '_blank');
        });
      };

      /**
       * Handler for items selected from the view selector. Will navigate to the new
       * state if not the current state. Will set button text and image.
       *
       * @param {String} state - The new state.
       */
      $scope.goToPage = function (state) {
        if (state !== viewUtils.getViewObject($state.current.name).state) {
          if (state === VIEW_STATES.METADATA_COMPARE_SELECT) {
            /**
             * Go to metadata compare select page and bypass going to previous state.
             * This is needed since both the select and results metadata compare page fall under metadataCompare.
             * If you go to results page, then back to admin, then to metadata compare select, the app tries to go
             * to previous state, which is results, and we don't want that.
             */
            $state.go(state);
          } else if (state === VIEW_STATES.LOG_HOME) {
            window.location.href = '/#/log';
          } else {
            viewUtils.go(state, $scope.stateParams);
          }
        }
      };

      /**
       * Function to launch the help modal.
       */
      $scope.openHelpModal = function () {
        // make sure the body is large enough to hold the help dialog
        bodyUtils.setBodyStyle({ height: '800px' });
        $uibModal
          .open({
            templateUrl: 'shared/modal/helpModal.tpl.html',
            controller: 'HelpModalCtrl',
            windowClass: 'sbsf-help-modal-window'
          })
          .result.then(
            function () {
              // case where modal is resolved
              bodyUtils.setBodyStyle(undefined);
            },
            function () {
              // case where modal is rejected
              bodyUtils.setBodyStyle(undefined);
            }
          );
      };

      /**
       * Function to launch the support modal.
       */
      $scope.openSupportModal = function () {
        // make sure the body is large enough to hold the support dialog
        bodyUtils.setBodyStyle({ height: '565px' });
        $uibModal
          .open({
            templateUrl: 'shared/modal/supportModal.tpl.html',
            controller: 'HelpModalCtrl',
            windowClass: 'sbsf-support-modal-window',
            scope: $scope
          })
          .result.then(
            function () {
              // case where modal is resolved
              bodyUtils.setBodyStyle(undefined);
            },
            function () {
              // case where modal is rejected
              bodyUtils.setBodyStyle(undefined);
            }
          );
      };

      $scope.toggleAsideMenu = function () {
        $rootScope.isAsideMenuOpen = !$rootScope.isAsideMenuOpen;
      };

      /**
       * Function to hide the help icon.
       */
      $scope.hideHelp = function () {
        $scope.showHelp = false;
      };

      /**
       * Function to determine if item is selected.
       * @returns {Boolean} - Flag is the item is selected or not.
       */
      $scope.isSelected = function (title) {
        return $scope.currentTitle === $filter('i18n')(title);
      };

      /**
       * Function used to get the percent complete of the trial period.
       *
       * @returns {Object} The style expression required by the template specifying
       * the width. The format is {width: string};
       */
      $scope.getPercentTrialDone = function () {
        var pct =
          $scope.inTrial && $scope.trialLength !== 0
            ? parseInt((($scope.trialLength - $scope.trialDaysRemaining) / $scope.trialLength) * 100, 10)
            : 0;
        pct = pct > 100 ? 100 : pct;
        return { width: pct + '%' };
      };

      /**
       * Function used to get the percent complete of the subscription period.
       *
       * @returns {Object} The style expression required by the template specifying
       * the width. The format is {width: string};
       */
      $scope.getPercentSubscriptionDone = function () {
        var pct = $scope.inRenewal ? parseInt(((30 - $scope.subscriptionDaysRemaining) / 30) * 100, 10) : 0;
        pct = pct > 100 ? 100 : pct;
        return { width: pct + '%' };
      };

      /**
       * Remove mentioned viewData from the copy of array with tabs. It will prevent displaying. Then check permission
       * and if curent user has it, display it back
       * @param {string} viewDataName - view data tab name
       * @param {number} permission - permission the tab requited to be displayed
       * @returns {*}
       */
      function checkViewDataPermission(viewDataName, permission) {
        delete $scope.viewData[viewDataName];
        return permissionService.hasPermission(permission).then((hasPermission) => {
          if (hasPermission) {
            $scope.viewData[viewDataName] = viewUtils.viewData[viewDataName];
          }
        });
      }

      // Watch the paymentInfo and if it changes update the scope.
      $scope.$watch(
        function () {
          return billingUtils.paymentInfo;
        },
        function () {
          if (billingUtils.paymentInfo) {
            $scope.updateBillingInfo(billingUtils.paymentInfo);
          }
        }
      );

      // Watch the $rootScope.maintenanceModeFlag to hide/show drop down.
      $scope.$watch(
        function () {
          return $rootScope.maintenanceModeFlag;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.isMaintenanceMode = $rootScope.maintenanceModeFlag;
          }
        }
      );

      // Watch the $rootScope.maintenanceModeFlag to hide/show drop down.
      $scope.$watch(
        function () {
          return $rootScope.accessError;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.accessError = $rootScope.accessError;
          }
        }
      );
    }
  )
  .run(function ($templateCache) {
    // Taken from ui-bootstrap-tpls.js
    // Override the bootstrap alert to use custom close button to resemble lightning design.
    $templateCache.put(
      'template/alert/alert.html',
      '<div class=\'alert\' ng-class=\'"alert-" + (type || "warning")\'>\n' +
        "    <button ng-show='closeable' type='button' class='close' ng-click='close()'>" +
        "       <svg aria-hidden='true' class='sbsf-alert-close'>" +
        "         <use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='images/symbols.svg#close'></use>" +
        '       </svg>' +
        '    </button>\n' +
        '    <div ng-transclude></div>\n' +
        '</div>\n' +
        ''
    );
    /* jshint +W109 */
  });
